/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import {
    TextBlock,
    Heading,
    Stack,
    DividerNew as Divider,
    DisplayHtmlContent,
    Box,
    Spinner,
    Text,
} from 'sarsaparilla';

import {
    AnchorPageWithSidebarLayout,
    AnchorPageSection,
} from 'shared-ui/components/AnchorPageWithSidebarLayout';

import { RateTable } from '../RateTable';

export function FeesTab({
    isFeesLoading,
    tourPrices,
    guestTypes,
    changesAndCancellationsHtml,
}) {
    return (
        <AnchorPageWithSidebarLayout className="te-facility-fees-tab">
            <Stack space="lg">
                <AnchorPageSection heading="Facility Rates">
                    <Stack space={['lg', 'md']} className="mt-3">
                        {isFeesLoading && (
                            <Box alignX="center">
                                <Spinner />
                            </Box>
                        )}

                        {!isFeesLoading && tourPrices.length !== 0 ? (
                            (
                                <div
                                    className="te-table-wrap te-faux-table-head"
                                    aria-hidden="true"
                                >
                                    <div>Tickets</div>
                                    <div>Rates</div>
                                </div>
                            ) &&
                            tourPrices.map((pricing, index) => (
                                <React.Fragment key={pricing.tour_id}>
                                    {index !== 0 && <Divider />}
                                    <div className="te-table-wrap">
                                        <Heading headingLevel={3} appearance="h6">
                                            {pricing.tour_name}
                                        </Heading>
                                        <RateTable
                                            tourName={pricing.tour_name}
                                            pricingByGuestTypeId={
                                                pricing.guest_type_pricing_by_guest_type_id
                                            }
                                            applicationFee={pricing.application_fee}
                                            reservationFee={pricing.reservation_fee}
                                            cancellationFee={pricing.cancellation_fee}
                                            lateCancellationFee={
                                                pricing.late_cancellation_fee
                                            }
                                            quantityDiscountThreshold={
                                                pricing.quantity_discount_threshold
                                            }
                                            cancellationWindowDescription={
                                                pricing.cancellation_window_description
                                            }
                                            pricing={pricing}
                                            guestTypes={guestTypes}
                                        />
                                    </div>
                                </React.Fragment>
                            ))
                        ) : (
                            <Text>
                                There are currently no tickets for sale at this location.
                            </Text>
                        )}
                    </Stack>
                </AnchorPageSection>

                <Divider />

                <AnchorPageSection heading="Changes and Cancellations">
                    <TextBlock>
                        <DisplayHtmlContent html={changesAndCancellationsHtml} />
                    </TextBlock>
                </AnchorPageSection>
            </Stack>
        </AnchorPageWithSidebarLayout>
    );
}

FeesTab.propTypes = {
    isFeesLoading: PropTypes.bool,
    tourPrices: PropTypes.arrayOf(PropTypes.object),
    guestTypes: PropTypes.arrayOf(PropTypes.object),
    changesAndCancellationsHtml: PropTypes.string,
};
